import { memo } from 'react';
import Link from 'next/link';
import styled from '@emotion/styled';

import ActionButton from './ActionButton';
import { css, cx } from '@emotion/css';
import { useRouteBuilder } from '../lib/hooks/useRouteBuilder';
import useTracking from '../lib/useTracking';
import { useCurrentRoute } from '../lib/useCurrentRoute';

const B = styled(ActionButton)`
  font-weight: normal;
  margin: 0 auto;

  width: fit-content;
  padding: 0.75rem 1.25rem;

  .verticalLayout.homePage & {
    padding: 0.75rem 3.25rem;
  }

  @media (min-width: 768px) {
    margin: 0 auto;

    .verticalLayout.homePage & {
      margin: 0 0 1rem;
    }
  }
`;

export interface RegistryButtonProps {
  title?: string;
  userDecisionArea?: string;
}

function RegistryButton({
  title = 'Browse our Registry',
  userDecisionArea = 'registry cta button',
}: RegistryButtonProps) {
  const newRoute = useRouteBuilder('registry');
  const currentRoute = useCurrentRoute();

  const trackGuest = useTracking('guest', currentRoute, userDecisionArea);

  return (
    <Link
      className={cx(css`
        text-decoration: none !important;
      `)}
      href={newRoute}
      as={newRoute}
      data-testid="registry-button"
      onClick={() => trackGuest('registry')}
    >
      <B>{title}</B>
    </Link>
  );
}

export default memo(RegistryButton);
